import { isArray, merge, mergeWith } from "lodash";
import {
  CREATE_NOTE_FAILURE,
  CREATE_NOTE_REQUEST,
  CREATE_NOTE_SUCCESS
} from "../types";

function customizer(objValue, srcValue) {
  if (isArray(objValue)) {
    return objValue.concat(srcValue);
  }
}

export default (state, action) => {
  switch (action.type) {
    case CREATE_NOTE_REQUEST:
      return {
        ...state,
        loadingDebtorNotes: true
      };
    case CREATE_NOTE_SUCCESS:
      return {
        ...state,
        loadingDebtorNotes: false,
        debtorNotes: mergeWith(
          merge({}, action.payload),
          state.debtorNotes,
          customizer
        )
      };
    case CREATE_NOTE_FAILURE:
      return {
        ...state,
        loadingDebtorNotes: false
      };
    default:
      return state;
  }
};
